import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "@/store";

axios.defaults.baseURL = process.env.VUE_APP_API_URL + "api";

Vue.use(VueAxios, axios);

axios.interceptors.request.use(
  config => {
    Vue.prototype.$Progress.start();
    store.commit("base/SET_LOADER", true);
    config.headers.common["Content-Type"] = "application/json";
    config.headers.common["Device-Type"] = "ADMIN";
    if (store.state.base.auth) {
      config.headers.common.Authorization =
        "Bearer " + store.state.base.auth.token;
    }
    return config;
  },
  err => Promise.reject(err)
);

axios.interceptors.response.use(
  response => {
    Vue.prototype.$Progress.finish();
    // Do something with response data
    store.commit("base/SET_LOADER", false);
    return response;
  },
  error => {
    Vue.prototype.$Progress.finish();
    let err = error.response;
    // Do something with response error
    return new Promise((resolve, reject) => {
      store.commit("base/SET_LOADER", false);
      /* store.dispatch("auth/setLoader", {
        loader: false
      }); */
      if (err.status === 401) {
        store.commit("auth/RESET");
        window.location.href = "/login";
        return;
      }

      var message = "";

      if (err.data) {
        if (err.data.error) {
          var errors = [];
          err.data.error.details.forEach(element => {
            errors.push(element.message);
          });
          message = errors.join("<br/>");
        } else message = err.data.message;

        Vue.swal("Error", message, "error");
      }
      reject(error);
    });
  }
);

export default {};
